import Swiper, {Navigation} from 'swiper';

const documentsSliders = Array.from(document.querySelectorAll('.j-documents-list-slider'));

documentsSliders.forEach((documentsSlider) => {
    let slider = {};
    const sliderContent = documentsSlider.querySelector('.j-documents-slider');
    const options = {
        init             : false,
        modules          : [Navigation],
        loop             : false,
        speed            : 800,
        spaceBetween     : 0,
        slidesPerView    : 'auto',
        slidesOffsetAfter: 30,
        navigation       : {
            nextEl: documentsSlider.querySelector('.j-documents-list-next'),
            prevEl: documentsSlider.querySelector('.j-documents-list-prev')
        },
        breakpoints: {
            1280: {
                allowTouchMove: false
            }
        }
    };

    slider = new Swiper(sliderContent, options);

    slider.init();
});

